import { GoogleLocation } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Google/Google.Controller.ts
export class GoogleAPI {
  static async getGoogleAccountAndLocationNames(orgId: number, appId: number) {
    return APIService.Server.get<GoogleLocation[]>(`/google/org/${orgId}/app/${appId}/account-and-location-names`);
  }

  static async getGoogleSheetNames(sheetId: string) {
    return APIService.Server.post<string[]>(`/google/sheet-names`, { sheetId });
  }

  static async readGoogleSheet(sheetId: string, range?: string) {
    return APIService.Server.post<{ headers: string[]; records: Record<string, string>[] }>(`/google/read-sheet`, { sheetId, range });
  }

  static async updateGoogleSheet(
    sheetId: string,
    range: string,
    values: any[][],
    options?: {
      backgroundColor?: string;
      sheetName?: string;
    }
  ) {
    return APIService.Server.post(`/google/update-sheet`, {
      sheetId,
      range,
      values,
      backgroundColor: options?.backgroundColor,
      sheetName: options?.sheetName
    });
  }
}
